var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0566 9.45282C15.5378 9.45282 15.1132 9.87735 15.1132 10.3962V11.6698C15.1132 13.566 13.5661 15.1132 11.6698 15.1132H5.3302C3.43398 15.1132 1.88679 13.566 1.88679 11.6698V5.33021C1.88679 3.43398 3.43398 1.88679 5.3302 1.88679H6.59436C7.11322 1.88679 7.53775 1.46227 7.53775 0.943397C7.53775 0.424529 7.11322 0 6.59436 0H5.3302C2.3868 0 0 2.39625 0 5.33021V11.6698C0 14.6132 2.39624 17 5.3302 17H11.6698C14.6132 17 17 14.6038 17 11.6698V10.3962C17 9.87735 16.5755 9.45282 16.0566 9.45282Z",
    fill: "#D9622A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03766 6.90585C3.66974 7.27378 3.66974 7.86812 4.03766 8.23604L7.11314 11.3115C7.45276 11.6511 7.91502 11.8397 8.39616 11.8397H8.50936C9.02823 11.8114 9.50937 11.5568 9.83012 11.1417L15.8207 3.43419C16.1414 3.0191 16.066 2.43416 15.6603 2.11341C15.2452 1.79265 14.6603 1.86817 14.3396 2.27383L8.39616 9.92473L5.3773 6.90585C5.00937 6.5379 4.41503 6.5379 4.04711 6.90585H4.03766Z",
    fill: "#D9622A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.3968df96ea930deaf8ad283ed8ccf1f2.svg";
export { ForwardRef as ReactComponent };